import { useState } from "react";
import QuestionMark from "../../images/products/question-mark.png";
import Plus from "../../images/products/Add_Plus.png";
import Minus from "../../images/minus.png";

function ProductsFaq() {
  const [dropdownActive, setDropDownActive] = useState("");

  return (
    <div className="products-faq">
      <div className="faq-heading">
        <img src={QuestionMark} alt="heading" />
        <p>Frequently Asked Questions</p>
      </div>
      <div className="faqs-div">
        <div
          className="faqs-questions"
          onClick={() => {
            dropdownActive !== "dropdown1"
              ? setDropDownActive("dropdown1")
              : setDropDownActive("");
          }}
        >
          <div>
            <p className="faqs-questions-title">What we do at Brandone?</p>
            <h2 className={dropdownActive === "dropdown1" ? "visible" : ""}>
              BrandOne is an Enterprise Resource Solution/platform company, that
              helps organizations, business(small and large scale) to automate
              their process and scale their businesses. Brandone helps them to
              bring their technological dreams for their companies/business to
              life. They develop bespoke solutions tailored to company/business
              needs.
            </h2>
          </div>
          {dropdownActive !== "dropdown1" ? (
            <img className="faqs-questions-dropdown" src={Plus} alt="plus" />
          ) : (
            <img className="faqs-questions-minus" src={Minus} alt="minus" />
          )}
        </div>
        <div
          className="faqs-questions"
          onClick={() => {
            dropdownActive !== "dropdown2"
              ? setDropDownActive("dropdown2")
              : setDropDownActive("");
          }}
        >
          <div>
            <p className="faqs-questions-title">Our development framework?</p>
            <h2 className={dropdownActive === "dropdown2" ? "visible" : ""}>
              We use Agile/scrum to manage our projects, SOLID/DRIVE design
              principles to guide our development. We use .netcore (latest),
              Angular js, React js, React Native for development.
            </h2>
          </div>
          {dropdownActive !== "dropdown2" ? (
            <img className="faqs-questions-dropdown" src={Plus} alt="plus" />
          ) : (
            <img className="faqs-questions-minus" src={Minus} alt="minus" />
          )}
        </div>
        <div
          className="faqs-questions"
          onClick={() => {
            dropdownActive !== "dropdown3"
              ? setDropDownActive("dropdown3")
              : setDropDownActive("");
          }}
        >
          <div>
            <p className="faqs-questions-title">What is an ERP?</p>
            <h2 className={dropdownActive === "dropdown3" ? "visible" : ""}>
              Enterprise Resource Platform, its software solution that aids
              companies/businesses processes in an integrated system. It helps
              drive efficiency and provide intelligent ways of doing things.
            </h2>
          </div>
          {dropdownActive !== "dropdown3" ? (
            <img className="faqs-questions-dropdown" src={Plus} alt="plus" />
          ) : (
            <img className="faqs-questions-minus" src={Minus} alt="minus" />
          )}
        </div>
        <div
          className="faqs-questions"
          onClick={() => {
            dropdownActive !== "dropdown4"
              ? setDropDownActive("dropdown4")
              : setDropDownActive("");
          }}
        >
          <div>
            <p className="faqs-questions-title">
              How long has Brandone been in existence?
            </p>
            <h2 className={dropdownActive === "dropdown4" ? "visible" : ""}>
              BrandOne has been in existence for 10 years now, the company was
              established in October 20th, 2013.
            </h2>
          </div>
          {dropdownActive !== "dropdown4" ? (
            <img className="faqs-questions-dropdown" src={Plus} alt="plus" />
          ) : (
            <img className="faqs-questions-minus" src={Minus} alt="minus" />
          )}
        </div>
      </div>
    </div>
  );
}

export default ProductsFaq;
